export default {
  props: [
    {
      attr: 'className',
      name: '班级名称',
      slot: 'className'
    },
    {
      attr: 'orgName',
      name: '所属校区',
      slot: 'orgName'
    },
    {
      attr: 'courseName',
      name: '教材',
      slot: 'courseName'
    },
    {
      attr: 'courseLayer',
      name: '等级'
    },
    {
      attr: 'lessonQty',
      name: '课时数'
    },
    {
      attr: 'mainTeacherName',
      name: '主讲老师',
      slot: 'mainTeacherName'
    },
    {
      attr: 'courseType',
      name: '课程类型',
      slot: 'courseType'
    },
    {
      attr: 'status',
      name: '课程状态',
      slot: 'status'
    },
    {
      attr: 'classStartTime',
      name: '上课时间',
      slot: 'classStartTime'
    },
    {
      attr: 'boughtQty',
      name: '学生数'
    }
  ]
};
